/** Virtual reference at the top-center of the checkbox; popover bottom-right attaches here. */
export const createTopCenterReference = (element) => ({
    getBoundingClientRect() {
        const rect = element.getBoundingClientRect();
        const x = rect.left + rect.width / 2;
        const y = rect.top;

        return {
            width: 0,
            height: 0,
            x,
            y,
            top: y,
            left: x,
            right: x,
            bottom: y,
        };
    },
});

export const createGetDisabledTrigger = (checkboxColId) => (target) => {
    const disabledCheckbox = target?.closest?.(
        `.ag-cell[col-id="${checkboxColId}"] .w5-cell-checkbox--disabled`,
    );
    if (disabledCheckbox) return disabledCheckbox;

    const cell = target?.closest?.(
        `.ag-cell[col-id="${checkboxColId}"].company-list-cell--checkbox-disabled`,
    );
    if (!cell) return null;

    return cell.querySelector('.w5-cell-checkbox') || cell;
};

export const isPopoverElement = (element) => Boolean(element?.closest?.('[data-selection-limit-popover]'));
